/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Org_Nightly_HintInputs */

const cs_portals_org_nightly_hint = /** @type {(inputs: Portals_Org_Nightly_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noční úloha znovu kontroluje portály v 03:15. Můžete spustit reconcile i teď.`)
};

const en_portals_org_nightly_hint = /** @type {(inputs: Portals_Org_Nightly_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A nightly job re-checks portals at 03:15. You can also run reconcile now.`)
};

/**
* | output |
* | --- |
* | "A nightly job re-checks portals at 03:15. You can also run reconcile now." |
*
* @param {Portals_Org_Nightly_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_org_nightly_hint = /** @type {((inputs?: Portals_Org_Nightly_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Org_Nightly_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_org_nightly_hint(inputs)
	return cs_portals_org_nightly_hint(inputs)
});